import type { ArtifactResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { isEnumValue } from '@ingenico/util-common';
import { artifactComponentTypeEnum, artifactTypeEnum } from '../../models/artifact.model';
import type { SystemPackageArtifactListResponseFront } from '../../models/systemPackage.model';

export function mapSystemPackagesVersionArtifactsById(
  data: ArtifactResourceListResponseV2Api,
): SystemPackageArtifactListResponseFront {
  return {
    pagination: data.pagination,
    artifacts: data.data.map((artifact) => ({
      artifactType: isEnumValue(artifact.type, artifactTypeEnum)
        ? artifactTypeEnum[artifact.type]
        : artifactTypeEnum.SW_PACKAGE,
      checksum: artifact.checksum,
      componentType: artifactComponentTypeEnum.SYSTEM_PACKAGE,
      name: artifact.fileName,
      mimeType: artifact.mimeType,
      size: artifact.size,
      id: artifact.id,
    })),
  };
}
